<template>
  <div class="left_sidebar size_no_repeat flex">
    <div class="left vue_flex vue_column">
      <ul class="left_boxs vue_flex_item">
        <!-- 单击路由 -->
        <li v-for="(item, index) in aside" :key="index" v-if="!item.children">
          <router-link
            class="aside_link"
            active-class="active"
            :to="{ name: pathFun(item.path) }"
            tag="li"
            >{{ item.name }}</router-link
          >
        </li>

        <!-- 多级路由 -->
        <el-menu
          class="el-menu-vertical-demo"
          background-color="#f4f9fd"
          :unique-opened="true"
          :default-active="activeMenu"
        >
          <el-submenu
            :index="`${tabIndex}`"
            v-for="(tab, tabIndex) in aside"
            :key="tabIndex"
            v-if="tab.children"
          >
            <template slot="title">
              <span class="submenu-title">{{ tab.name }}</span>
            </template>
            <div
              v-for="(tabtwo, tabtwoIndex) in tab.children"
              :key="tabtwoIndex"
            >
              <el-menu-item-group v-if="!tabtwo.children">
                <el-menu-item :index="tabtwo.path">
                  <router-link
                    class="aside_link"
                    :active-class="isActive(tabtwo.path) ? 'active' : ''"
                    :to="{ name: pathFun(tabtwo.path) }"
                    tag="li"
                    >{{ tabtwo.name }}</router-link
                  >
                </el-menu-item>
              </el-menu-item-group>
              <el-submenu :index="tabtwo.path" v-else>
                <template slot="title">{{ tabtwo.name }}</template>
                <el-menu-item
                  :index="tabthree.path"
                  v-for="(tabthree, tabthreeIndex) in tabtwo.children"
                  :key="tabthreeIndex"
                  v-if="!tabthree.hidden"
                >
                  <router-link
                    class="aside_link"
                    :active-class="isActive(tabthree.path) ? 'active' : ''"
                    :to="{ name: pathFun(tabthree.path) }"
                    tag="li"
                    >{{ tabthree.name }}</router-link
                  >
                </el-menu-item>
              </el-submenu>
            </div>
          </el-submenu>
        </el-menu>
      </ul>
    </div>
    <div class="right" :style="{ background: `rgba(255, 255, 255, ${backPpacity})` }" >
      <headerboxs></headerboxs>
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { isExternal } from "../utils/utils";
import { mapGetters } from "vuex";
import headerboxs from "@/components/headerboxs/index"
export default {
  components: { headerboxs },
  data() {
    return {
      backPpacity: 0,
      other: [],
    };
  },
  props: {
    aside: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      let pathArray = path.split("/");
      return pathArray[pathArray.length - 1];
    },
  },

  mounted() {
    this.pathtoFun(this.$route);
  },

  watch: {
    $route(to, from) {
      // 监听路由变化，执行相关操作
      console.log("路由变化，从", from.path, "到", to.path);
      this.pathtoFun(to);
    },
  },

  methods: {
    isActive(route) {
      let pathArray = this.$route.path.split("/");
      let routes = route.split("/").pop();
      return routes === pathArray[pathArray.length - 1];
    },

    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
    },

    pathtoFun(to) {
      switch (to.path) {
        case "/main/level1/level1-1":
        case "/main/level2/level2-1":
        case "/main/level3/level3-1":
        case "/main/level4/level4-1":
          this.backPpacity = 0;
          break;
        default:
          this.backPpacity = 1;
          break;
      }
    },

    pathFun(val) {
      const result = val.split("/").pop();
      return result;
    },
  },
};
</script>
<style lang="scss" scoped>
.left_sidebar {
  min-width: 1786px;
  height: 100%;
  position: absolute;
  .left,
  .right {
    height: 100%;
  }
  .left {
    width: 206px;
    background: rgba(247, 248, 252, 1);
    box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
    border-radius: 16px;
    .left_title {
      font-size: 20px;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      padding: 36px 0px 30px;
      text-align: center;
    }
    .left_boxs {
      overflow-y: auto;
      scrollbar-width: none; /* 隐藏滚动条 */
      -ms-overflow-style: none; /* 针对IE和Edge */
      .aside_link {
        // padding: 26px 0px 22px;
        padding: 18px 0px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        text-align: center;
        font-size: 18px;
        line-height: 14px;
        cursor: pointer;
        &.active {
          background: rgba(231, 235, 247, 1);
          color: rgba(30, 91, 209, 1);
        }
      }
      .aside_link:hover {
        background: rgba(231, 235, 247, 1);
        color: rgba(30, 91, 209, 1);
      }
    }
  }
  .right {
    width: 1580px;
    box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
    // border-radius: 20px;
    overflow-y: auto;
    overflow-x: auto;
    scrollbar-width: none; /* 隐藏滚动条 */
    -ms-overflow-style: none; /* 针对IE和Edge */
  }
}

/deep/.el-menu-item {
  width: 100%;
  padding: 0px !important;
  height: auto;
  line-height: auto;
}
.el-menu-item-group /deep/.el-menu-item-group__title {
  padding: 0px !important;
}

/deep/.el-menu-item.is-active {
  color: rgba(51, 51, 51, 1);
}

.submenu-title{
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 26px;
  color: #232323;
  line-height: 26px;
}
</style>





// WEBPACK FOOTER //
// src/structures/left_sidebar.vue